"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconNavigationWithSubLinks = _interopRequireDefault(require("./IconNavigationWithSubLinks"));

var _IconNavigationNoSubLinks = _interopRequireDefault(require("./IconNavigationNoSubLinks"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconNavigationLink = function IconNavigationLink(_ref) {
  var toggleMobileNav = _ref.toggleMobileNav,
      to = _ref.to,
      name = _ref.name,
      icon = _ref.icon,
      subLinks = _ref.subLinks;
  return _react["default"].createElement("li", null, subLinks && subLinks.length ? _react["default"].createElement(_IconNavigationWithSubLinks["default"], {
    toggleMobileNav: toggleMobileNav,
    subLinks: subLinks,
    icon: icon,
    name: name
  }) : _react["default"].createElement(_IconNavigationNoSubLinks["default"], {
    toggleMobileNav: toggleMobileNav,
    to: to,
    icon: icon,
    name: name
  }));
};

var DropDownShape = {
  name: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  visible: _propTypes["default"].bool
};
IconNavigationLink.propTypes = {
  to: _propTypes["default"].string.isRequired,
  icon: _propTypes["default"].string.isRequired,
  toggleMobileNav: _propTypes["default"].bool.isRequired,
  subLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape))
};
IconNavigationLink.defaultProps = {
  subLinks: []
};
var _default = IconNavigationLink;
exports["default"] = _default;